import LiveActivityFeed from "./LiveActivityFeed";

export default function AdminLiveActivityFeed({ onSelectJob }) {
  return <LiveActivityFeed feedType="admin" onSelectJob={onSelectJob} />;
}
